import { StrictMode, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import UpdateBanner from "./components/UpdateBanner";
import InstallBanner from "./components/InstallBanner";
import { applyPwaUpdate, registerServiceWorker } from "./pwa";
import "./styles.css";

function Root() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  // Đăng ký service worker một lần duy nhất (không phụ thuộc React lifecycle — sw.js tự quản
  // vòng đời của nó). Gọi ở module scope thay vì useEffect để không đăng ký lại khi StrictMode
  // double-invoke effect ở dev.
  if (typeof window !== "undefined" && !(window as unknown as { __swRegistered?: boolean }).__swRegistered) {
    (window as unknown as { __swRegistered?: boolean }).__swRegistered = true;
    registerServiceWorker({ onUpdateAvailable: () => setUpdateAvailable(true) });
  }

  return (
    <>
      <InstallBanner />
      <App />
      {updateAvailable ? (
        <UpdateBanner onReload={applyPwaUpdate} onDismiss={() => setUpdateAvailable(false)} />
      ) : null}
    </>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Không tìm thấy #root");
}

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
